// Package Imports
import React from 'react';

// Style Imports 
import styles from './cartCheckoutTemporaryAuthorization.module.scss';

export default function CartCheckoutTemporaryAuthorization() {
  return (
    <section className={styles.cartCheckoutTemporaryAuthorization}>
      <p>
        <span>*Temporary Authorized Total:</span> We will pre-authorize your card for the total of your order <span>PLUS 15% </span> to cover shipping and any approved order changes. Your card won&apos;t be charged until you authorize the final amount at delivery.
      </p>
    </section>
  );
}
